import { styled } from "styled-components";
import { Checkbox, FormControlLabel, TextField, Box } from '@mui/material';
import { ModalBodyText, ModalHeaderText } from './modalTypography';

export const ModalContainer = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: '500px',
  backgroundColor: 'white',
  borderRadius: '8px',
  padding: '24px',
  outline: 'none',
  maxHeight: '90vh',
  overflowY: 'auto',
});

export const ModalHeader = styled(ModalHeaderText)({
  fontSize: '20px',
  fontWeight: 600,
  marginBottom: '16px',
  color: '#333',
});

export const ModalBody = styled.div({
  marginBottom: '24px',
});

export const ModalFooter = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  gap: '16px',
  marginTop: '24px',
});

export const StyledCheckbox = styled(Checkbox)({
  padding: '8px',
  marginRight: '8px',
  color: '#76B041 !important',
  '&.Mui-checked': {
    color: '#76B041 !important',
  },
  '& .MuiSvgIcon-root': {
    fontSize: '1.5rem',
  },
});

export const StyledFormControlLabel = styled(FormControlLabel)({
  alignItems: 'center',
  display:'flex',
  margin: 0,
  '& .MuiFormControlLabel-label': {
    margin: '4px 0 0 0',
    flex: 1,
  },
  '& .MuiButtonBase-root': {
    padding: '8px',
    marginRight: '8px',
  },
});

export const ReasonItem = styled.div({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '12px',
  width: '100%',
  minHeight: '40px',
  borderBottom: '1px solid #f0f0f0',
  '&:last-child': {
    borderBottom: 'none',
  },
});

export const ErrorText = styled.div({
  color: '#d32f2f',
  fontSize: '14px',
  marginTop: '8px',
});

export const CustomTextArea = styled(TextField)({
  width: '100%',
  marginTop: '16px',
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
  },
});

export const LoadingContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '40px 0',
  color : '#76B041',
});

export const LoadingText = styled(ModalBodyText)({
  marginTop: '16px',
  color: '#666',
});